
<template>
  <el-container>
    <el-header height="0.64rem">
      <div class="header flexBox">
        <div class="flexBox-center nav-left">
            <img :src="titleImg" class="topimg"> 
        </div>
        <div class="flexBox-right nav-center">
          <ul class="uls">                
              <li class="lis"><router-link to="/home" class="as">首页</router-link></li>
              <li class="lis"><router-link to="/develop" class="as">开发引导</router-link></li>
              <li class="lis"><router-link to="/about" class="as">关于我们</router-link></li>               
              <li class="lis"><a @click="goUrl()" target="_blank" class="as">登录/注册</a></li> 
          </ul>
        </div>
      </div>
    </el-header>
  </el-container>
</template>
  
<script>
  import img1 from '@/assets/images/logo_official-website.png'
  export default {
    name: 'LuffyHeader',
    computed: {
      productUrl() {
        if (window.location.hostname === 'localhost') {
          return 'https://inner-dev.topband-cloud.com:743/tsmart/#/login'
        }
        if (window.location.hostname === 'www.topband-cloud.com') {
          return 'https://iot.topband-cloud.com/#/login'
        }
        return window.location.origin + '/tsmart/#/login'
      }
    },
    data(){
      return {
        titleImg:img1
      }
    },
    methods: {
      goUrl() {
        location.href = this.productUrl
        // window.open(path, "_blank")
      }
    },
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
  @import '~styles/global.scss';
   @import "~styles/index.scss";
  .el-header{
    padding:0px !important;
  }
  .header{
    position: fixed;
    top:0;
    width:100%;
    height: vw(64);
    line-height: vw(64);
    z-index:99; 
    background-color: #fff;
    @extend %align-items_center;
    @extend %justify-content_flex-end;
    -webkit-box-shadow: 0px 5px 14.24px 1.76px rgba(0,0,0,0.04);
    box-shadow: 0px 5px 14.24px 1.76px rgba(0,0,0,0.04);
    .nav-left{
      
      .topimg{
        width: auto;
        vertical-align: middle;
      }
    }
    .nav-center{
     
      .uls{
        width: max-content;
        list-style-type: none;
        white-space:nowrap;
        overflow: hidden; 
        .lis{
          float:left; 
          margin-right:vw(20);  
          position: relative;
          overflow: hidden;
          .as{
            display: block;             
            text-align: center;
            /* padding: 3px; */
            overflow: hidden;
            text-decoration: none; 
            color:black;
            width:vw(88);
            height::vw(30);
            line-height: vw(30);                                 
            border-radius:vw(20);
            &:hover {
              color:white !important;
              background-color:#1cc0c9;
            }
          }
          .is-active{
            color:white !important;
            background-color:#1cc0c9;
          }
        }
      }
    }
  }
 
</style>



// WEBPACK FOOTER //
// src/components/LuffyHeader.vue